import React from 'react';
import cryingBearImage from '@/assets/app/images/common/bottom/crying-bear.png';
import AppButton from '@/shared/components/ui/new/AppButton';

interface MessageSheetProps {
  type: 'INFO' | 'ALERT' | 'CONFIRM';
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  onConfirmTitle?: string;
  onCancelTitle?: string;
}

export const MessageSheet: React.FC<MessageSheetProps> = ({
  type = 'INFO',
  message,
  onConfirm,
  onCancel,
  onConfirmTitle,
  onCancelTitle,
}) => {
  return (
    <div className="p-6 space-y-6">
      {/* 캐릭터 이미지 */}
      {type === 'ALERT' && (
        <div className="flex justify-center">
          <img src={cryingBearImage} alt="울고있는 캐릭터" />
        </div>
      )}

      {/* 메시지 */}
      <h2
        className="text-xl font-bold text-center"
        dangerouslySetInnerHTML={{ __html: message }}
      ></h2>

      {/* 확인 버튼 */}
      <AppButton
        onConfirm={type === 'CONFIRM' ? onConfirm : onCancel}
        message={onConfirmTitle || '확인'}
      />
      {type === 'CONFIRM' && (
        <AppButton
          onConfirm={onCancel}
          style={{
            marginTop: 10,
            backgroundColor: '#D4D4D4',
            boxShadow: '0px 3.5px 0px 0px #B5B5B5',
          }}
          message={onCancelTitle || '취소'}
        />
      )}
    </div>
  );
};
